//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  props: {
    order: {
      type: Number,
      default: 0,
    },
    header: {
      type: String,
      default: "dilmah-head-1 text-md-left text-center",
    },
    link: {
      type: Object,
      default: () => ({
        url: null,
        urlText: null,
      }),
    },
    image: {
      type: String,
      default: "images/founder-mess-4.png",
    },
    text: {
      type: String,
      default: `My family tea has grown into an international brand that is
              enjoyed in over 100 countries. Dilmah owes its success to the
              quality of Ceylon Tea. Our business was founded therefore on an
              enduring connection to the land and the communities in which we
              operate. We have pioneered a comprehensive commitment to
              minimising our impact on the planet, fostering respect for the
              environment and ensuring its protection by encouraging a
              harmonious coexistence of man and nature. The environment is
              central to Dilmah's business, and Dilmah Conservation was
              established as an affirmation of this core commitment to
              environmental sustainability.`,
    },
  },
};
